import { render, staticRenderFns } from "./CalculatorsForm.vue?vue&type=template&id=38b3b427&scoped=true"
import script from "./CalculatorsForm.vue?vue&type=script&lang=js"
export * from "./CalculatorsForm.vue?vue&type=script&lang=js"
import style0 from "./CalculatorsForm.vue?vue&type=style&index=0&id=38b3b427&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3b427",
  null
  
)

export default component.exports